// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__GvE_u","label":"Category_label__21bsh","content":"Category_content__1EvnW","header":"Category_header__12XhG","location":"Category_location__1K_MK"};